import { createContext } from 'react'

export interface Holding {
  'Symbol': string;
  'Name': string;
  'Intrument': string;
  'Sector': string;
  'U. Shares': string;
  'E. Shares': string;
  'Market Value': string;
  'U. Market Value': string;
  'E. Market Value': string;
  'Purchase Price': string;
  'Commissions': string;
  'Purchase Date': string;
  'Price': string;
  'Cost Basis': string;
  'Gain': string;
  '% Gain': string;
  'Annualized Return': string;
  'Total Shares': string;
  '% Portfolio': string;
  '% Sector': string;
  'CAPM': string;
  'Expected Return $': string;
  '1 Day Change %': string;
  'Years Owned': string;
  'Weighted Years Owned': string;
  'P/E': string;
  'Weighted P/E': string;
  'Beta': string;
  'Weighted Beta': string;
  '# Shares Outstanding (Millions)': string;
  'Market Cap (Millions': string;
  'Weighted Market Cap': string;
  'Size': string;
  'Style (Quantity)': string;
  'Dividend': string;
  'Dividend Yield': string;
  'Annual Dividend Income': string;
  '1 Week Change %': string;
  '7 Day %': string;
  '30 Day %': string;
  '90 Day %': string;
}


export interface SectorDiversification {
  'Financial': Sector;
  'Fixed Income': Sector;
  'Utilities': Sector;
  'Industrial': Sector;
  'Materials': Sector;
  'Consumer Discretionary': Sector;
  'Technology': Sector;
  'Healthcare': Sector;
  'Consumer Staples': Sector;
  'Mixed': Sector;
  'Cash': Sector;
  'Total': Sector;
}
export interface Sector {
  'Sector': string;
  'Sector Weight': string;
  'Benchmark': string;
  'Over/(Under)': string;
  'Sector $': string;
}


export interface AssetClassDiversification {
  'Equity': Instrument;
  'ETF': Instrument;
  'ETF-FI': Instrument;
  'Cash': Instrument;
  'Total:': Instrument;
}
export interface Instrument {
  'Instrument': string;
  'Instrument Weight': string;
  'Benchmark': string;
  'Over/(Under)': string;
  'Instrument $': string;
}


export interface SizeStyleDiversification {
  'Large Growth': SizeStyle;
  'Large Core': SizeStyle;
  'Large Value': SizeStyle;
  'Mid Growth': SizeStyle;
  'Mid Core': SizeStyle;
  'Mid Value': SizeStyle;
  'Small Growth': SizeStyle;
  'Small Core': SizeStyle;
  'Small Value': SizeStyle;
  'Mixed': SizeStyle;
  'Cash': SizeStyle;
  'Total:': SizeStyle;
}
export interface SizeStyle {
  'Size/Style': string;
  'Size/Style Weight': string;
  'Benchmark': string;
  'Over/(Under)': string;
  'Size/Style $': string;
}

const StateContext = createContext({
  portfolio: [] as Holding[],
  sectorDiversification: {} as SectorDiversification,
  assetClassDiversification: {} as AssetClassDiversification,
  sizeStyleDiversification: {} as SizeStyleDiversification
})

export const ContextProvider = StateContext.Provider

export default StateContext